import React, { useEffect, useState } from "react";
import { FiImage, FiSave, FiUpload } from "react-icons/fi";
import { supabase } from "../supabaseClient";

function AboutThree() {
  const [description, setDescription] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [recordId, setRecordId] = useState(null);
  const [uploading, setUploading] = useState(false);

  useEffect(() => {
    const getData = async () => {
      const res = await supabase.from("AboutThree").select("*");
      if (res.data && res.data.length > 0) {
        setDescription(res.data[0].description);
        setImageUrl(res.data[0].image_url ?? "");
        setRecordId(res.data[0].id);
      }
    };
    getData();
  }, []);

  const saveDescription = async () => {
    if (recordId) {
      await supabase.from("AboutThree").update({ description }).eq("id", recordId);
    } else {
      const res = await supabase.from("AboutThree").insert([{ description }]).select();
      setRecordId(res.data[0].id);
    }
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    const fileName = `about-company-${Date.now()}-${file.name}`;
    await supabase.storage.from("images").upload(fileName, file);
    const { data } = supabase.storage.from("images").getPublicUrl(fileName);
    const url = data.publicUrl;
    setImageUrl(url);
    if (recordId) {
      await supabase.from("AboutThree").update({ image_url: url }).eq("id", recordId);
    } else {
      const res = await supabase.from("AboutThree").insert([{ description, image_url: url }]).select();
      setRecordId(res.data[0].id);
    }
    setUploading(false);
  };

  return (
    <div className="about-stack">
      <section className="about-card">
        <h2 className="about-card__title" style={{ marginBottom: "1rem" }}>Company Image</h2>
        <div className="about-upload-row">
          <div className="about-upload-placeholder" aria-hidden>
            {imageUrl ? <img src={imageUrl} alt="Company" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "inherit" }} /> : <FiImage />}
          </div>
          <div className="about-upload-hint">
            <p>Upload a new image for the company section (recommended: 800×600px)</p>
            <label className="about-btn" style={{ cursor: "pointer" }}>
              <FiUpload aria-hidden />
              {uploading ? "Uploading…" : "Upload Image"}
              <input type="file" accept="image/*" style={{ display: "none" }} onChange={handleImageUpload} />
            </label>
          </div>
        </div>
      </section>

      <section className="about-card">
        <h2 className="about-card__title" style={{ marginBottom: "0.75rem" }}>Company Description</h2>
        <label className="about-label" htmlFor="company-desc">Description</label>
        <textarea
          id="company-desc"
          className="about-textarea"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
        <div className="about-card__foot">
          <button type="button" className="about-btn" onClick={saveDescription}>
            <FiSave aria-hidden />
            Save Changes
          </button>
        </div>
      </section>
    </div>
  );
}

export default AboutThree;